import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';
import {
  FnbInvoiceGetDto,
  FnbInvoiceItemGetDto,
  OrderGetMinToEmptyFormik,
  OrderGetMinToFormik,
} from 'svila-common';
import { AxiosResponse } from 'axios';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import OrdersApi from '../../../../services/api/OrdersApi';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import validationSchema from '../validationSchema';
import AutocompleteComponent from '../../../../components/common/forms/Autcomplete/AutocompleteComponent';
import { API_URL, SHIPPING_TYPES, FILE_UPLOAD_TYPES, ROLES, DATE_FORMAT_WITH_TIME } from '../../../../utils/constants';
import AutocompleteStaticComponent from '../../../../components/common/forms/Autcomplete/AutocompleteStaticComponent';
import { constantsToAutocomplete } from '../../../../utils/misc';
import SecondaryNavigation from '../../../../components/common/navigation/SecondaryNavigation';
import ButtonComponent from '../../../../components/common/forms/Button/ButtonComponent';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import DatePickerInputComponent from '~/src/components/common/forms/DatePickerInput/DatePickerInputComponent';
import RolesDependent from '~/src/components/common/RolesDependent';
import FnbInvoicesApi from '~/src/services/api/FnbInvoicesApi';

import styled from 'styled-components';
import Barcode from 'react-barcode';
import moment from 'moment';
import { Col, Row } from 'react-bootstrap';

import fnbLogo from '~/src/static/img/fnb.png';
import backgroundLine from '~/src/static/img/BackgroundLine.png';
import { DATE_FORMAT } from '~/src/utils/constants';
import { FnbItemGetDto, FnbOrderGetWithItemsDto } from 'svila-common';

interface ParamProps {
  id?: string;
}

export default function FnbInvoiceEdit(): React.ReactElement {
  const { id } = useParams<ParamProps>();
  const [item, setItem] = useState<FnbInvoiceGetDto | null>(null);
  const history = useHistory();
  // const saveItem = async (values, setSubmitting) => {
  //   setSubmitting(true);
  //   const containerId = values.containerId || null;
  //   const convertedValues = {
  //     ...values,
  //     containerId,
  //     orderType: item?.orderType,
  //     warehouseOwnerId: values.warehouseOwnerId,
  //   };
  //   let res: AxiosResponse<FnbInvoiceGetDto> | null = null;
  //   if (id) {
  //     res = await OrdersApi.update(id, convertedValues);
  //   } else {
  //     res = await OrdersApi.create(convertedValues);
  //   }
  //   if (res.status === StatusCodes.OK) {
  //     const orderId = res.data?.id;
  //     history.push(`/orders/details/${orderId}`);
  //   } else {
  //     setSubmitting(false);
  //   }
  // };

  const getItem = async (orderId: string): Promise<void> => {
    const res = await FnbInvoicesApi.get(orderId);
    setItem(res.data);
  };

  useEffect(() => {
    if (id) {
      getItem(id);
    }
  }, []);

  // const handleBack = () => {
  //   history.push('/orders');
  // };

  // const getInitialValues = (() => {
  //   if (!id) {
  //     return OrderGetMinToEmptyFormik();
  //   } else {
  //     if (item) {
  //       return OrderGetMinToFormik(item);
  //     } else {
  //       return null;
  //     }
  //   }
  // })();

  return (
    <WhitePad isFluid>
      {item && (
        <Wrapper style={{ display: 'block' }}>
          <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Content style={{ marginTop: 5 }}>
              <Logo src={fnbLogo} alt="fnbLogo" />
            </Content>
            <Content style={{ display: 'flex', flexDirection: 'column' }}>
              <TitleComponent title={`Фактура №${item.uniqueNumber}`} />
              <Barcode value={item.fnbUniqueNumber} height={40} width={3} flat={true} />
            </Content>
            <Content style={{ textAlign: 'right', marginTop: 5 }}>
              <span>FnB FOOD AND BEVERAGE</span>
              <span>КАФЕ И СЛАДКИ</span>
              <b style={{ textAlign: 'right', color: '#FF3155' }}>www.fnb.bg</b>
            </Content>
          </Box>
          <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Content>
              <GreyText>ПОЛУЧАТЕЛ:</GreyText>
              <Text>
                Име:{' '}
                <b>
                  {item.receiverFirstName} {item.receiverLastName}
                </b>
              </Text>
              <Text>
                Адрес: <b>{item.receiverAddress}</b>
              </Text>
              <Text>
                Град: <b>{item.receiverCity}</b>
              </Text>
              <Text>
                Държава: <b>България</b>
              </Text>
              <Text>
                Телефон: <b>{item.receiverPhoneNumber}</b>
              </Text>
            </Content>
            <Content style={{ justifyContent: 'space-between' }}>
              <Text style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Дата Поръчка:</span> <b>{item ? moment(item.orderDate).format(DATE_FORMAT) : null}</b>
              </Text>
              <Text style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Дата Фактура:</span> <b>{item ? moment(item.invoiceDate).format(DATE_FORMAT) : null}</b>
              </Text>
              <div>
                {/* <Text style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                  Доставка: <b>{item.deliveryTotal} лв.</b>
                </Text> */}
                {/* if there is discount add that row */}
                {item.discount > 0 && (
                  <Text style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                    Отстъпка: <b>{item.discount} лв.</b>
                  </Text>
                )}
                <Text style={{ display: 'flex', justifyContent: 'space-between' }}>
                  Обща стойност: <b style={{ fontSize: 20 }}>{item.subTotal - item.discount} лв.</b>
                </Text>
                <Text style={{ display: 'flex', justifyContent: 'space-between' }}>
                  Словом:
                </Text>
                <Text style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <b style={{}}>{item.subTotalSlovom}</b>
                </Text>
              </div>
            </Content>
            <Content style={{ alignItems: 'flex-end' }}>
              <GreyText>ДОСТАВЧИК:</GreyText>
              <Text>
                Име: <b>БОНО ФАЙН ФУУДС ЕООД</b>
              </Text>
              <Text>
                ЕИК: <b>201483575</b>
              </Text>
              <Text>
                Адрес: <b>пл. Градска болница № 1,</b>
              </Text>
              <Text>
                <b>ет. 3, офис 10</b>
              </Text>
              <Text>
                Град: <b>Хасково</b>
              </Text>
              <Text>
                Телефон: <b>+359 89 7066399</b>
              </Text>
            </Content>
          </Box>
          <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Content>
              <div>
                <GreyText>Избран метод за плащане:</GreyText>
                <br />
                <Text>
                  <b>{item.paymentMethod}</b>
                </Text>
              </div>
            </Content>
            <Content>
              <div>
                <GreyText>Плащане:</GreyText>
                <br />
                <Text>
                  <b>{item.paymentDate ? `Платено на ${moment(item.paymentDate).format(DATE_FORMAT_WITH_TIME)}` : 'Няма данни за извършено плащане'}</b>
                </Text>
              </div>
            </Content>
            <Content style={{ alignItems: 'flex-end' }}>
              <div>
                <GreyText>Начин за доставка:</GreyText>
                <br />
                <Text>
                  <b>{item.deliveryType}</b>
                </Text>
              </div>
            </Content>
          </Box>
          <div>
            <BackgroundLine src={backgroundLine} alt="backgroundLine" />
          </div>
          <TableStyle>
            <TheadStyle>
              <tr>
                <th>
                  <GreyText>ПРОДУКТИ</GreyText>
                </th>
                <th style={{ textAlign: 'right' }}>
                  <GreyText>ЕДИНИЧНА ЦЕНА</GreyText>
                </th>
                <th style={{ textAlign: 'right' }}>
                  <GreyText>БРОЙ</GreyText>
                </th>
                <th style={{ textAlign: 'right' }}>
                  <GreyText>ЦЕНА</GreyText>
                </th>
              </tr>
            </TheadStyle>
            <TBodyStyles>
              {item?.fnbInvoiceItems?.map((product: FnbInvoiceItemGetDto) => {
                return (
                  <TrStyle>
                    <TdStyle>
                      {product.productName}
                      <br></br>
                      <span style={{ fontSize: 18, color: '#999' }}>{product.productCode}</span>
                    </TdStyle>
                    <TdStyle style={{ textAlign: 'right' }}>{product.singleUnitPrice} лв.</TdStyle>
                    <TdStyle style={{ textAlign: 'right' }}>{product.quantity} бр.</TdStyle>
                    <TdStyle style={{ textAlign: 'right', padding: 0 }}>
                      <b>{Math.round(product.singleUnitPrice * product.quantity * 100) / 100} лв.</b>
                    </TdStyle>
                  </TrStyle>
                );
              })}
            </TBodyStyles>
          </TableStyle>
        </Wrapper>
      )}
    </WhitePad>
  );
}

const Logo = styled.img`
  width: 150px;
  height: auto;
`;

const TheadStyle = styled.thead`
  border-bottom: 1px solid #eaeaea;
`;

const Wrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const TableStyle = styled.table`
  width: 100%;
  margin-bottom: 20px;
  padding-bottom: 50px;
  &tr:nth-child(odd) {
    background-color: #eee;
  }
  &tr:nth-child(even) {
    background-color: #fff;
  }
`;

const GreyText = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #999;
`;

const Text = styled.p`
  font-size: 16px;
  margin: 0;
`;

const TdStyle = styled.td`
  font-size: 16px;
  padding: 10px;
`;

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 11px 12px;
  flex: 1;
`;

const Box = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TrStyle = styled.tr`
  border-bottom: 1px solid #eaeaea;
`;

const TBodyStyles = styled.tbody`
  // ${TrStyle}:nth-child(even) {
  //   background: #eee;
  // }
`;

const BackgroundLine = styled.img`
  width: 100%;
  margin: 30px 0;
`;
